import CharacterBackgroundImage from 'assets/images/characterBackground.svg';
import cn from 'classnames/bind';
import { getColorType } from 'utils/types';

import s from './CharacterBackground.module.scss';

const cx = cn.bind(s);

const CharacterBackground = ({
  color = 'mint', className, transparent = true, ...attrs
}) => {
  const combinedClassName = cx(color, className, { transparent });
  return (
    <CharacterBackgroundImage className={combinedClassName} {...attrs} />
  );
};

CharacterBackground.propTypes = {
  color: getColorType(['grey', 'brown']),
};

export default CharacterBackground;
